/**
 * 캠페인 목록 파싱 및 필터링 유틸리티
 *
 * API 응답 포맷이 Campaign[] | { campaigns: Campaign[] } 두 가지로 올 수 있어
 * 일관되게 배열로 변환하는 parseCampaignList와,
 * 원본 소스의 페이지별 필터링 패턴을 재현하는 프리셋 필터를 제공한다.
 */

export interface CampaignBase {
  _id?: string;
  id?: string;
  status?: string;
  name?: string;
  hidden?: boolean;
}

/** Minimal campaign shape for simple pickers/lookups (name + status, no full detail). */
export interface MinimalCampaign {
  _id: string;
  name: string;
  status?: string;
  hidden?: boolean;
  campaignGenre?: string;
}

/**
 * API 응답(Campaign[] | { campaigns?: Campaign[] })을 배열로 정규화
 */
export function parseCampaignList<T extends CampaignBase>(
  data: T[] | { campaigns?: T[] } | null | undefined,
): T[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return data.campaigns ?? [];
}

/* ── 필터 프리셋 ─────────────────────────────────── */

/** in_progress + completed 만 포함 (좌측 캠페인 셀렉터 공통 패턴) */
export function filterActiveAndCompleted<T extends CampaignBase>(list: T[]): T[] {
  return list.filter((c) => c.status === 'in_progress' || c.status === 'completed');
}

/** completed 제외 (우측 "캠페인에 추가" 드로어 패턴) */
export function filterExcludeCompleted<T extends CampaignBase>(list: T[]): T[] {
  return list.filter((c) => c.status !== 'completed');
}
